import { memo, useState } from 'react'
import AddCarCategoryModal from '../modal/AddCarCategoryModal'

function AddCarCategoriesButton({ carModels, setCarModels }) {
  const [newCategory, setShowModal] = useState(false)

  return (
    <>
      <button
        type={'button'}
        onClick={() => setShowModal(true)}
        className="w-full md:w-fit shadow-add-more h-11 mx-auto px-5 py-2.5 text-md font-medium text-white
                flex items-center justify-center bg-blue rounded-md hover:bg-link
                transition-all duration-300 ease-linear whitespace-nowrap"
      >
        <span className={'text-white pl-2'}>ثبت دسته بندی جدید</span>
        <i className={'icon-add text-white'} />
      </button>
      {newCategory && (
        <AddCarCategoryModal
          carModels={carModels}
          setCarModels={setCarModels}
          setShowModal={setShowModal}
        />
      )}
    </>
  )
}

export default memo(AddCarCategoriesButton)
